import type { InvoiceLookup } from "../lib/gboModels";
import { normalizeInvoiceReferenceCode } from "../lib/lookupCode";
import { gboApi } from "./gboApiBase";

export type InvoiceQueryArg = {
  invoiceCode: string;
};

export const invoiceApi = gboApi.injectEndpoints({
  endpoints: (builder) => ({
    getInvoice: builder.query<InvoiceLookup, InvoiceQueryArg>({
      query: ({ invoiceCode }) => ({
        url: `invoices/${encodeURIComponent(normalizeInvoiceReferenceCode(invoiceCode))}`,
      }),
      providesTags: (_result, _error, { invoiceCode }) => [
        { type: "Invoice", id: normalizeInvoiceReferenceCode(invoiceCode) },
      ],
    }),
  }),
});

export const { useGetInvoiceQuery } = invoiceApi;
